/* ============================================================================
   GlassReady — Service Matchmaker engine (shared asset)
   Config-driven quiz + live recommendations. Supports:
     - Single-language sections: one <script data-gr-config> (legacy).
     - Bilingual sections: <script data-gr-config-en> + <script data-gr-config-ar>
       with a visitor EN | العربية toggle. Answers persist across switches.
   Loaded as a theme asset so it runs in both the theme editor and storefront.
   ============================================================================ */
(function () {
  if (window.__grMatchmakerLoaded) { grBoot(); return; }
  window.__grMatchmakerLoaded = true;

  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  function initRoot(root) {
    if (root.dataset.grInit) return;

    function parse(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
    var configs = {}, bilingual = false;
    var enEl = root.querySelector("[data-gr-config-en]");
    var arEl = root.querySelector("[data-gr-config-ar]");
    var singleEl = root.querySelector("[data-gr-config]");
    if (enEl && arEl) { var e = parse(enEl), a = parse(arEl); if (e && a) { configs.en = e; configs.ar = a; bilingual = true; } }
    if (!bilingual && singleEl) { var c = parse(singleEl); if (c) configs[root.dataset.grLang || "en"] = c; }
    var langs = Object.keys(configs);
    if (!langs.length) return;
    root.dataset.grInit = "1";

    var lang = (root.dataset.grLang && configs[root.dataset.grLang]) ? root.dataset.grLang : langs[0];

    var qWrap = root.querySelector("[data-gr-questions]");
    var recWrap = root.querySelector("[data-gr-recs]");
    var addWrap = root.querySelector("[data-gr-addons-wrap]");
    var fill = root.querySelector("[data-gr-fill]");
    var pct = root.querySelector("[data-gr-pct]");
    var submit = root.querySelector("[data-gr-submit]");
    var emailBtn = root.querySelector("[data-gr-email]");
    var reset = root.querySelector("[data-gr-reset]");
    var state = {}; // persists across language switches (question ids are shared)

    var cfg, SERVICES, QUESTIONS, UI, LB, TH, SEP, ADDONS;
    function loadCfg() {
      cfg = configs[lang];
      SERVICES = cfg.services || {};
      QUESTIONS = cfg.questions || [];
      UI = cfg.ui || {};
      LB = UI.labels || {};
      TH = cfg.thresholds || { perfect: 5, rec: 3 };
      SEP = UI.sep || ", ";
      ADDONS = (cfg.addons || []).filter(function (a) { return a && a.name; }).map(function (a) {
        a.pairsArr = String(a.pairs || "").toLowerCase().replace(/\s+/g, "").split(",").filter(Boolean);
        return a;
      });
    }

    function buildQuestions() {
      qWrap.innerHTML = "";
      QUESTIONS.forEach(function (q, qi) {
        if (!(q.id in state)) state[q.id] = [];
        var sel = state[q.id];
        var block = document.createElement("div");
        block.className = "gr-q";
        var opts = q.options.map(function (o, oi) {
          var tick = q.type === "multi" ? '<span class="tick">\u2713</span>' : "";
          var on = sel.indexOf(oi) > -1 ? "true" : "false";
          return '<button type="button" class="gr-opt" data-q="' + qi + '" data-o="' + oi + '" aria-pressed="' + on + '">' + tick + "<span>" + esc(o.label) + "</span></button>";
        }).join("");
        block.innerHTML =
          '<div class="gr-q-h"><span class="gr-q-n">' + (qi + 1) + '</span><div><div class="gr-q-t">' + esc(q.title) + '</div><div class="gr-q-hint">' + esc(q.hint) + "</div></div></div><div class=\"gr-opts\">" + opts + "</div>";
        qWrap.appendChild(block);
      });
    }

    function applyText() {
      if (!bilingual) return;
      var t = cfg.t || {};
      root.querySelectorAll("[data-t]").forEach(function (el) { if (t[el.dataset.t] != null) el.textContent = t[el.dataset.t]; });
      root.querySelectorAll("[data-ph]").forEach(function (el) { if (t[el.dataset.ph] != null) el.placeholder = t[el.dataset.ph]; });
      root.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
      root.querySelectorAll("[data-gr-setlang]").forEach(function (b) {
        b.setAttribute("aria-pressed", b.dataset.grSetlang === lang ? "true" : "false");
      });
    }

    // option clicks (delegated on the stable parent; survives re-render)
    qWrap.addEventListener("click", function (ev) {
      var btn = ev.target.closest(".gr-opt");
      if (!btn || !qWrap.contains(btn)) return;
      var qi = +btn.dataset.q, oi = +btn.dataset.o, q = QUESTIONS[qi], arr = state[q.id];
      if (q.type === "single") {
        state[q.id] = arr[0] === oi ? [] : [oi];
        qWrap.querySelectorAll(".gr-q")[qi].querySelectorAll(".gr-opt").forEach(function (b) {
          b.setAttribute("aria-pressed", (+b.dataset.o === state[q.id][0]) ? "true" : "false");
        });
      } else {
        var pos = arr.indexOf(oi);
        if (pos > -1) arr.splice(pos, 1); else arr.push(oi);
        btn.setAttribute("aria-pressed", pos > -1 ? "false" : "true");
      }
      recompute();
    });

    function scores() {
      var s = {}; Object.keys(SERVICES).forEach(function (k) { s[k] = 0; });
      QUESTIONS.forEach(function (q) {
        (state[q.id] || []).forEach(function (oi) {
          var w = (q.options[oi] && q.options[oi].w) || {};
          Object.keys(w).forEach(function (k) { s[k] = (s[k] || 0) + w[k]; });
        });
      });
      return s;
    }
    function ranked() {
      var s = scores();
      return Object.keys(s).map(function (k) { return { key: k, score: s[k] }; })
        .filter(function (r) { return r.score > 0 && SERVICES[r.key]; })
        .sort(function (a, b) { return b.score - a.score; });
    }
    function matched(list) {
      var keys = {}; list.forEach(function (r) { keys[r.key] = true; });
      return ADDONS.filter(function (a) { return a.pairsArr.length === 0 || a.pairsArr.some(function (k) { return keys[k]; }); });
    }

    function recompute() {
      var answered = QUESTIONS.filter(function (q) { return (state[q.id] || []).length > 0; }).length;
      var p = QUESTIONS.length ? Math.round(answered / QUESTIONS.length * 100) : 0;
      if (fill) fill.style.width = p + "%";
      if (pct) pct.textContent = p + "%";
      var list = ranked();
      if (!list.length) {
        recWrap.innerHTML = '<div class="gr-empty">' + esc(UI.empty || "") + "</div>";
        if (addWrap) addWrap.innerHTML = "";
        validate(); return;
      }
      recWrap.innerHTML = list.map(function (r) {
        var sv = SERVICES[r.key];
        var badge = r.score >= TH.perfect ? '<span class="gr-badge perfect">' + esc(UI.badgePerfect) + "</span>"
          : r.score >= TH.rec ? '<span class="gr-badge rec">' + esc(UI.badgeRec) + "</span>"
          : '<span class="gr-badge opt">' + esc(UI.badgeOpt) + "</span>";
        return '<div class="gr-rec"><span class="em">' + esc(sv.emoji) + '</span><div class="info"><div class="nm">' + esc(sv.name) + '</div><div class="bl">' + esc(sv.blur) + "</div></div>" + badge + '<a href="' + esc(sv.url) + '">' + esc(UI.viewLink) + "</a></div>";
      }).join("");
      if (addWrap) {
        var adds = matched(list);
        addWrap.innerHTML = adds.length
          ? '<div class="gr-addons"><h4>' + esc(UI.addonsTitle) + '</h4><p class="cap">' + esc(UI.addonsCap) + "</p>" +
            adds.map(function (a) {
              var link = a.url ? '<a href="' + esc(a.url) + '">' + esc(UI.addLink) + "</a>" : "";
              return '<div class="gr-add"><span class="em">' + esc(a.emoji || "\u2795") + '</span><div class="info"><div class="nm">' + esc(a.name) + "</div>" + (a.blurb ? '<div class="bl">' + esc(a.blurb) + "</div>" : "") + "</div>" + link + "</div>";
            }).join("") + "</div>"
          : "";
      }
      validate();
    }

    function field(n) { return root.querySelector('[data-gr-field="' + n + '"]'); }
    function fval(n) { var el = field(n); return el ? el.value.trim() : ""; }
    function validate() {
      var base = fval("name") && fval("clinic") && QUESTIONS.some(function (q) { return (state[q.id] || []).length > 0; });
      if (submit) submit.disabled = !(base && fval("phone"));
      if (emailBtn) emailBtn.disabled = !(base && fval("email"));
    }
    ["name", "clinic", "location", "email", "phone"].forEach(function (n) {
      var el = field(n);
      if (el) el.addEventListener("input", function () { el.classList.remove("err"); validate(); });
    });

    function labelsFor(qid) {
      var q = QUESTIONS.filter(function (x) { return x.id === qid; })[0];
      if (!q) return [];
      return (state[qid] || []).map(function (oi) { return q.options[oi].label; });
    }
    function buildLines() {
      var email = fval("email"), phone = fval("phone"), loc = fval("location"),
          list = ranked(), adds = matched(list), L = [];
      L.push(String(UI.waTitle || "").replace("{business}", cfg.business || "")); L.push("");
      L.push((UI.waName || "") + fval("name")); L.push((UI.waClinic || "") + fval("clinic"));
      if (loc) L.push((UI.waLoc || "") + loc);
      if (email) L.push((UI.waEmail || "") + email);
      if (phone) L.push((UI.waPhone || "") + phone);
      L.push("");
      var g = labelsFor("goal"); if (g.length) L.push((LB.goal || "") + g.join(SEP));
      var gp = labelsFor("gap"); if (gp.length) L.push((LB.gap || "") + gp.join(SEP));
      var hv = labelsFor("have"); if (hv.length) L.push((LB.have || "") + hv.join(SEP));
      var tm = labelsFor("time"); if (tm.length) L.push((LB.time || "") + tm.join(SEP));
      var bd = labelsFor("budget"); if (bd.length) L.push((LB.budget || "") + bd.join(SEP));
      L.push(""); L.push(UI.waRecTitle || "");
      if (list.length) {
        list.forEach(function (r) {
          var m = r.score >= TH.perfect ? "\u2705" : (r.score >= TH.rec ? "\ud83d\udc4d" : "\u2022");
          L.push(m + " " + SERVICES[r.key].name);
        });
      } else { L.push(UI.waNoRec || ""); }
      if (adds.length) { L.push(""); L.push(UI.waAddTitle || ""); adds.forEach(function (a) { L.push("\u2795 " + a.name); }); }
      L.push(""); L.push(UI.waClose || "");
      return L;
    }
    function markMissing(names) {
      var miss = false;
      names.forEach(function (n) { var el = field(n); if (!el || !el.value.trim()) { if (el) el.classList.add("err"); miss = true; } });
      return miss;
    }
    function openExternal(href, newTab) {
      var a = document.createElement("a");
      a.href = href; a.rel = "noopener noreferrer";
      if (newTab) a.target = "_blank";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { if (a.parentNode) a.parentNode.removeChild(a); }, 120);
    }
    if (submit) submit.addEventListener("click", function () {
      if (markMissing(["name", "clinic", "phone"])) return;
      var wa = String(cfg.whatsapp || "").replace(/[^0-9]/g, ""), text = encodeURIComponent(buildLines().join("\n"));
      openExternal(wa ? ("https://wa.me/" + wa + "?text=" + text) : ("https://wa.me/?text=" + text), true);
    });
    if (emailBtn) emailBtn.addEventListener("click", function () {
      if (markMissing(["name", "clinic", "email"])) return;
      var subj = encodeURIComponent(String(UI.emailSubject || "Service quotation request").replace("{business}", cfg.business || "")),
          body = encodeURIComponent(buildLines().join("\r\n"));
      openExternal("mailto:" + (cfg.emailTo || "") + "?subject=" + subj + "&body=" + body, false);
    });
    if (reset) reset.addEventListener("click", function () {
      QUESTIONS.forEach(function (q) { state[q.id] = []; });
      qWrap.querySelectorAll(".gr-opt").forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
      ["name", "clinic", "location", "email", "phone"].forEach(function (n) {
        var el = field(n); if (el) { el.value = ""; el.classList.remove("err"); }
      });
      recompute();
    });

    // language toggle
    function setLang(l) {
      if (!configs[l] || l === lang) return;
      lang = l; root.dataset.grLang = l;
      loadCfg(); applyText(); buildQuestions(); recompute();
    }
    root.querySelectorAll("[data-gr-setlang]").forEach(function (b) {
      b.addEventListener("click", function () { setLang(b.dataset.grSetlang); });
    });

    loadCfg();
    applyText();
    buildQuestions();
    recompute();
  }

  function grBoot() {
    document.querySelectorAll(".gr-matchmaker[data-gr-root]").forEach(initRoot);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", grBoot);
  } else {
    grBoot();
  }
  document.addEventListener("shopify:section:load", grBoot);
})();